import { Link } from 'react-router-dom';

/**
 * Brand logo. Auto-swaps between the dark (blue) source PNG and a filter-inverted
 * white variant so the mark stays legible on any background.
 *
 * Props:
 *   variant: 'dark' (default) → original blue logo — use on LIGHT backgrounds
 *            'light'         → white logo (CSS-inverted)  — use on DARK backgrounds
 *   mark:    boolean — icon-only pin/target glyph (no wordmark)
 *   size:    'sm' | 'md' | 'lg'
 *   noLink:  boolean — render as <span> instead of <Link to="/">
 */
export default function Logo({ variant = 'dark', mark = false, size = 'md', noLink = false }) {
  const heights = { sm: 26, md: 36, lg: 52 };
  const h = heights[size] || heights.md;
  const src = mark ? '/cnm-logo-mark.png' : '/cnm-logo-full.png';
  const filterStyle = variant === 'light'
    ? { filter: 'brightness(0) invert(1)' }
    : undefined;

  const img = (
    <img
      src={src}
      alt="Connect Near Me"
      style={{ height: h, width: 'auto', display: 'block', ...(filterStyle || {}) }}
      draggable={false}
      data-testid={`cnm-logo-${variant}${mark ? '-mark' : ''}`}
    />
  );

  if (noLink) return <span className="inline-flex items-center">{img}</span>;
  return (
    <Link to="/" className="inline-flex items-center" aria-label="Connect Near Me · Home">
      {img}
    </Link>
  );
}
